import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { rubricPersistSelectors } from '../../../../../../store/selectors/rubric.persist.selectors'
import { rubricPersistActions } from '../../../../../../store/slices/rubric.persist.slice'
import { Steps } from 'antd'
import { useParams } from 'react-router'

const ImportRubricSteps = () => {
    const { token } = useParams()
    const currentStep = useSelector(rubricPersistSelectors.currentStep(token))
    const questions = useSelector(rubricPersistSelectors.questions(token))
    const dispatch = useDispatch()

    const onChange = step => {
        dispatch(rubricPersistActions.setCurrentStep({ token, step }))
    }

    const items = [
        { id: 'import', title: 'Import File', disabled: true },
        { id: 'calibration', title: 'Calibration', disabled: true },
        { id: 'question-matching', title: 'Question Matching', disabled: true },
    ]
    if (questions) questions.map(question => items.push({ id: question.id, title: question.name || question.content }))

    return <Steps current={currentStep} onChange={onChange} orientation='vertical' items={items} size='small' />
}

export default ImportRubricSteps
